<template>
  <v-dialog v-model="dialog" class="dialog-wrapper" width="650px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :dark="$getPrimaryButton('dark')" depressed :rounded="$getPrimaryButton('rounded')"
        :outlined="false" color="success" v-bind="attrs" v-on="on" large @click="openDialog">
        <v-icon left>mdi-clock-edit</v-icon>Fichaje manual
      </v-btn>
    </template>
    <v-container fluid>
      <v-card outlined class="p-3" :elevation="$getCardOptions('elevation')">
        <v-card-title class="p-0">
          <v-spacer></v-spacer>
          <v-btn class="ml-auto" :rounded="$getPrimaryButton('rounded')"
            :color="$getPrimaryButton('color2')" @click="closeDialog" :disabled="false"
            :loading="loading" icon large>
            <v-icon large>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title class="pt-0">
          <section-header :first="ComputedTexts.first" :second="ComputedTexts.second" />
        </v-card-title>
        <v-card-text v-if="!loading">
          <v-form ref="form">
            <div v-if="holidayInfo.isHoliday" class="holiday-banner mb-4" :class="'holiday-type-' + holidayInfo.colorKey">
              <v-icon small left class="mr-1">mdi-calendar-alert</v-icon>
              <span>{{ holidayInfo.type }}</span>
              <span v-if="holidayInfo.description"> - {{ holidayInfo.description }}</span>
            </div>
            <div v-if="step === 4" class="py-3">
              <label class="input-field--label pt-3"> Tipo de fichaje: </label>
              <v-text-field v-model="ComputedClockEntryType" readonly focus hide-details
                  :color="$getColor('vuetifyColor1')" outlined prepend-inner-icon="mdi-clock-alert-outline">{{ ClockEntryType }}
              </v-text-field>
              <label class="input-field--label pt-3"> Fecha: </label>
              <v-text-field v-model="ClockEntryDate" readonly focus hide-details
                  :color="$getColor('vuetifyColor1')" outlined prepend-inner-icon="mdi-calendar">{{ ClockEntryType }}
              </v-text-field>
              <label class="input-field--label pt-3"> Hora: </label>
              <v-text-field v-model="ClockEntryTime" readonly focus hide-details
                  :color="$getColor('vuetifyColor1')" outlined prepend-inner-icon="mdi-clock">{{ ClockEntryType }}
              </v-text-field>
            </div>
            <v-btn v-if="step === 1" class="p-2 white--text" :rounded="$getPrimaryButton('rounded')"
              :outlined="$getPrimaryButton('outlined')" color="success" @click="setEntrada"
              :disabled="false" :loading="loading" block x-large>
              <v-icon class="pr-3" left>mdi-clock-plus</v-icon>
              Entrada
            </v-btn>
            <v-btn right v-if="step === 1" class="p-2 mt-4 white--text"
              :rounded="$getPrimaryButton('rounded')" :outlined="$getPrimaryButton('outlined')"
              :color="$getPrimaryButton('color')" @click="setSalida" :disabled="false"
              :loading="loading" block x-large>
              <v-icon class="pr-3" left>mdi-location-exit</v-icon>
              Salida
            </v-btn>
            <v-date-picker v-model="ClockEntryDate" locale="es" full-width first-day-of-week="1"
              :max="DateTimeNow" v-if="step === 2">
            </v-date-picker>
            <v-time-picker v-model="ClockEntryTime" format="24hr" locale="es" full-width
              v-if="step === 3" large></v-time-picker>
          </v-form>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-container>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn v-if="ClockEntryDate && step === 2 || ClockEntryTime && step === 3"
                class="pr-2 white--text" :rounded="$getPrimaryButton('rounded')"
                :outlined="$getPrimaryButton('outlined')" :color="$getPrimaryButton('color')"
                @click="nextStep" :disabled="false" :loading="loading" width="48%" large block>
                Siguiente
              </v-btn>
              <v-btn v-if="step === 4" class="pr-2 white--text"
                :rounded="$getPrimaryButton('rounded')" :outlined="$getPrimaryButton('outlined')"
                color="success" @click="addClockEntryManual" :disabled="false" :loading="loading" width="48%"
                large block>
                <v-icon class="pr-3" left>mdi-upload</v-icon>
                Añadir
              </v-btn>
              <!--
                <v-btn class="ml-auto" :rounded="$getPrimaryButton('rounded')"
                :color="$getPrimaryButton('color2')" @click="closeDialog" :disabled="false"
                :loading="loading" width="48%" large>
                Atrás
              </v-btn>
               -->
            </v-row>
          </v-container>

        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import clockEntryService from '@/services/clockentry.service';
import WorkCenterCalendarService from '@/services/workcenter-calendar.service';
import ConfigureTimeService from '@/services/configure-time.service';

import SectionHeader from '@/components/Headers/SectionHeader.vue';
import moment from 'moment-timezone';

export default {
  name: 'clock-entry-register',
  data: () => ({

    dialog: false,
    loading: false,
    currentDateTime: null,
    DateTimeNow: new Date().toISOString(),
    ClockEntryDate: null,
    ClockEntryType: null,
    ClockEntryTime: null,
    calendarEntries: [],

    typeColorMap: {
      'FIESTA NACIONAL': 'red',
      'FIESTA AUTONOMICA': 'yellow',
      'FIESTA LOCAL': 'green',
      'FIESTA CONVENIO': 'orange',
      'AJUSTE HOR. CONVENIO': 'lightblue',
      'NO LABORABLE NO RECUP.': 'purple',
    },

    step: 1,

  }),
  props: {
    workerId: {
      required: true,
    },
    worker: {
      required: false,
    },
    isAdmin: {
      type: Boolean,
      required: true,
      default: false,
    },
    currentValue: {
      required: false,
    },
  },
  components: {
    SectionHeader,
  },
  computed: {
    ComputedClockEntryType() {
      if (this.ClockEntryType === 0) {
        return 'ENTRADA';
      } if (this.ClockEntryType === 1) {
        return 'SALIDA';
      }
      return null;
    },
    ComputedDateTimeNow() {
      return this.DateTimeNow.toLocaleString();
    },
    ComputedUnixTime() {
      if (this.ClockEntryDate && this.ClockEntryTime) {
        // Combinar la fecha y la hora en un string compatible con Date
        const dateTimeString = `${this.ClockEntryDate}T${this.ClockEntryTime}:00`;
        // Crear un objeto Date con la fecha y hora combinada
        const dateObj = new Date(dateTimeString);

        // Asegurarse de que el objeto Date está configurado para la zona horaria de España
        // (España está en la zona horaria Central European Time, CET, o Central European Summer Time, CEST)
        // Podemos configurar el objeto Date para la zona horaria local
        dateObj.toLocaleString('es-ES', { timeZone: 'Europe/Madrid' });

        // Obtener el valor Unix Time (en segundos)
        const unixTimestampSeconds = Math.floor(dateObj.getTime() / 1000);

        // Mostrar el valor Unix Time
        return unixTimestampSeconds;
      }
      return null;
    },
    ComputedTexts() {
      if (this.loading) {
        return { first: '', second: 'Cargando...' };
      }
      if (this.step === 1) {
        return { first: 'Selecciona', second: 'el tipo de fichaje' };
      }
      if (this.step === 2) {
        return { first: 'Selecciona la fecha', second: 'del día del fichaje' };
      }
      if (this.step === 3) {
        return { first: 'Selecciona la hora', second: 'del fichaje' };
      }
      if (this.step === 4) {
        return { first: 'Comprueba los datos', second: 'y haz click en `Añadir`' };
      }
      return { first: 'Pulsa atras', second: 'para volver...' };
    },
    holidayInfo() {
      const targetDate = this.ClockEntryDate
        ? moment(this.ClockEntryDate).format('YYYY-MM-DD')
        : moment(this.DateTimeNow || new Date()).format('YYYY-MM-DD');
      const calendarEntry = this.calendarEntries && this.calendarEntries.find((entry) => moment.utc(entry.date).format('YYYY-MM-DD') === targetDate);
      if (calendarEntry) {
        if (!calendarEntry.available) {
          const type = calendarEntry.type || 'FESTIVO';
          const description = calendarEntry.description || '';
          const colorKey = this.typeColorMap[type] || 'grey';
          return {
            isHoliday: true,
            type,
            description,
            colorKey,
          };
        }
        return { isHoliday: false };
      }
      const isWeekend = ConfigureTimeService.isWeekend(targetDate);
      if (isWeekend) {
        return {
          isHoliday: true,
          type: 'FIN DE SEMANA',
          description: '',
          colorKey: 'grey',
        };
      }
      return { isHoliday: false };
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.updateCurrentDateTime();
        this.fetchCalendarEntries();
      }
    },
    worker: {
      handler() {
        this.fetchCalendarEntries();
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchCalendarEntries();
  },
  methods: {
    fetchCalendarEntries() {
      const workCenterId = (this.worker && this.worker.workCenter && this.worker.workCenter.id) || this.$store.state.projectId;
      if (!workCenterId) return;
      const params = {
        page: 0,
        size: 1000,
        sort: 'date',
        direction: 'asc',
      };
      WorkCenterCalendarService.getCalendarEntriesByWorkCenter(workCenterId, params)
        .then((response) => {
          this.calendarEntries = (response.data && response.data.content) ? response.data.content : [];
        })
        .catch((error) => {
          console.error('Error fetching calendar entries in CreateClockEntryManual:', error);
        });
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.ClockEntryDate = null;
      this.ClockEntryType = null;
      this.ClockEntryTime = null;
      this.step = 1;
      this.dialog = false;
    },
    setEntrada() {
      this.ClockEntryType = 0;
      this.nextStep();
    },
    setSalida() {
      this.ClockEntryType = 1;
      this.nextStep();
    },
    nextStep() {
      this.step += 1;
    },
    updateCurrentDateTime() {
      const now = new Date();
      // Formatear la fecha y hora según tus necesidades
      const formattedDateTime = this.formatDateTime(now);
      this.currentDateTime = formattedDateTime;
    },
    formatDateTime(dateTime) {
      const date = new Date(dateTime);
      const options = {
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric',
      };
      return new Intl.DateTimeFormat('es-ES', options).format(date);
    },
    addClockEntryManual() {
      this.loading = true;
      clockEntryService.addClockEntryManual(this.worker.id, this.ComputedUnixTime, this.ClockEntryType)
        .then(() => {
          this.refreshClockEntries();
          this.closeDialog();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refreshClockEntries() {
      this.$emit('refreshClockEntries');
    },
  },
};
</script>
<style scoped>
.input-clock--label {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: calc(var(--base) * 3);
  margin-left: auto;
  margin-right: auto;
  color: var(--color1);
  font-weight: 300;
}

.box-info {
  display: flex;
  margin: auto;
}

.holiday-banner {
  width: 100%;
  padding: 10px 16px;
  border-radius: 6px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.3px;
}

.holiday-type-red {
  background-color: #ffcdd2;
  color: #b71c1c;
  border: 1px solid #ef9a9a;
}
.holiday-type-red .v-icon {
  color: #b71c1c !important;
}

.holiday-type-yellow {
  background-color: #fff9c4;
  color: #f57f17;
  border: 1px solid #fff176;
}
.holiday-type-yellow .v-icon {
  color: #f57f17 !important;
}

.holiday-type-green {
  background-color: #c8e6c9;
  color: #1b5e20;
  border: 1px solid #81c784;
}
.holiday-type-green .v-icon {
  color: #1b5e20 !important;
}

.holiday-type-orange {
  background-color: #ffe0b2;
  color: #e65100;
  border: 1px solid #ffb74d;
}
.holiday-type-orange .v-icon {
  color: #e65100 !important;
}

.holiday-type-lightblue {
  background-color: #b3e5fc;
  color: #01579b;
  border: 1px solid #4fc3f7;
}
.holiday-type-lightblue .v-icon {
  color: #01579b !important;
}

.holiday-type-purple {
  background-color: #e1bee7;
  color: #4a148c;
  border: 1px solid #ba68c8;
}
.holiday-type-purple .v-icon {
  color: #4a148c !important;
}

.holiday-type-grey {
  background-color: #eeeeee;
  color: #424242;
  border: 1px solid #e0e0e0;
}
.holiday-type-grey .v-icon {
  color: #424242 !important;
}
</style>
